import {
  SET_ACTIVE_USERS,
  SET_ALL_USERS,
  SET_AT_RISK_USERS,
  SET_INACTIVE_USERS,
  SET_NEW_USERS,
  SET_USER_VIEWS,
} from "../actionType";

const initState = {
  all_users: [],
  active_users: [],
  at_risk_users: [],
  inactive_users: [],
  new_users: [],
  user_views: [],
};

const usersReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_ALL_USERS:
      return {
        ...state,
        all_users: action.payload,
      };
    case SET_ACTIVE_USERS:
      return {
        ...state,
        active_users: action.payload,
      };
    case SET_AT_RISK_USERS:
      return {
        ...state,
        at_risk_users: action.payload,
      };
    case SET_INACTIVE_USERS:
      return {
        ...state,
        inactive_users: action.payload,
      };
    case SET_NEW_USERS:
      return {
        ...state,
        new_users: action.payload,
      };
    case SET_USER_VIEWS:
      return {
        ...state,
        user_views: action.payload,
      };

    default:
      return state;
  }
};

export default usersReducer;
